import Vue from 'vue'
import App from './App.vue'
//引入路由
import router from './router'
//element ui按需引入
import { MessageBox } from 'element-ui'
import {Cascader, Input, Form, FormItem, message, Pagination, Image, Checkbox, Menu, Submenu, MenuItem, MenuItemGroup, Table, TableColumn, Button, Option, Select, Radio, RadioGroup, DatePicker, Upload, Dialog, Dropdown, DropdownMenu, DropdownItem, Switch, Breadcrumb, BreadcrumbItem, Loading } from 'element-ui'
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Pagination)
Vue.use(Image)
Vue.use(Checkbox)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Button)
Vue.use(Option)
Vue.use(Select)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Switch)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Cascader)
Vue.use(Loading)
Vue.config.productionTip = false
Vue.prototype.$message = message
Vue.prototype.$confirm = MessageBox.confirm
import moment from 'moment'
Vue.filter('datefmt', function(input, fmtstring) { //当input为时间戳，需转为Number类型
	if (input) {
		return moment(input).format(fmtstring);
	} else {
		return "";
	}
});
Vue.filter('datefmt2', function(input, fmtstring) { //当input为时间戳，需转为Number类型
	if (input) {
		return moment.unix(input).format(fmtstring);
	} else {
		return "";
	}
});
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
